export const badNameCharacters = '+<>!@#$%^&*()[]{}“`?/\\|;:~=_0123456789';
